import axios, { AxiosInstance } from "axios";
import { Address } from '@/models/Address';

class GeoService {
    private static instance: GeoService;

    static getInstance(): GeoService {
        GeoService.instance = GeoService.instance ?? new GeoService();
        return GeoService.instance;
    }

    private readonly token: string = "68855abea8bfb9a9d56e67b10aed1aa818ecbb60";//"04f06b95e54fe802330a4139a4da3839f999139a";
    private readonly axiosInstance: AxiosInstance = axios.create();
    private readonly baseurl: string = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/";
    private readonly queryUrl: string = this.baseurl + "suggest/address";
    private readonly locatUrl: string = this.baseurl + "detectAddressByIp";

    constructor() {
        this.axiosInstance.defaults.headers.common["Authorization"] = 'token ' + this.token;
        this.axiosInstance.defaults.headers.common["Content-Type"] = 'application/json';
        this.axiosInstance.defaults.headers.post["Content-Type"] = 'application/json';
        this.axiosInstance.defaults.headers.common["Accept"] = 'application/json';
    }

    async makeAdvancedQuery(query: any): Promise<GeoResp[]> {
        const res = await this.axiosInstance.post(this.queryUrl, JSON.stringify(query));
        const data = res.data.suggestions.map(this.mapResponse);
        return data;
    }
    async makeQuery(query: string): Promise<GeoResp[]> {
        const res = await this.axiosInstance.post(this.queryUrl, JSON.stringify({ query: query }));
        const data = res.data.suggestions.map(this.mapResponse);
        return data;
    }

    async locateByIp(): Promise<GeoResp[]> {
        const res = await this.axiosInstance.get(this.locatUrl);
        res.data.location.value = res.data.location.data.source;
        return [this.mapResponse(res.data.location)];
    }

    private mapResponse(x: any): GeoResp
    {
        const settlementType: string[] = ["тер. СНТ", "мкр", "квл", "гск", "кв-л"];
        const template = "_";
        x.value = x.value.replace(template, " ");

        function replaceTemplateChar(data: any, field: string, template: string){
            if (!!data[field]) {
                data[field] = data[field].replace(template, " ");
                data[field+'_type'] = data[field+'_type'].replace(template, " ");
            }
        }
        const replacedFields: string[] = ['city','settlement','region','area','street']
        replacedFields.forEach(field=>replaceTemplateChar(x.data,field,template));

        return ({
            value: x.value,
            data: {
                state: !!x.data.region ? `${x.data.region} ${x.data.region_type}.` : null,
                region: !!x.data.area ? `${x.data.area} ${x.data.area_type}.` : null,
                street: !!x.data.street
                    ? `${x.data.street_type}. ${x.data.street}`
                    : !!x.data.settlement
                        ? settlementType.includes(x.data.settlement_type)
                            ? `${x.data.settlement}`
                            : `${x.data.settlement_with_type}`
                        : null,
                house: !!x.data.house ? `${x.data.house}` : null,//`${x.data.house_type}. ${x.data.house}` : null,
                apartment: !!x.data.flat ? `${x.data.flat}` : null,//`${x.data.flat_type}. ${x.data.flat}` : null,
                city: !!x.data.city
                    ? `${x.data.city_type}. ${x.data.city}`
                    : `${x.data.settlement_type}. ${x.data.settlement}`,
                zip: x.data.postal_code,
                building: x.data.block ? `${x.data.block}` : null,
                fiasId: x.data.fias_id,
                stateFiasId: !x.data.city ? `${x.data.region_fias_id}` : null,
                cityFiasId: x.data.city_fias_id ?? x.data.settlement_fias_id,
                streetFiasId: x.data.street_fias_id,
                kladrId: x.data.kladr_id,
                okato: x.data.okato,
                value: x.value
            } as Address
        } as GeoResp);
    }
}

export default GeoService.getInstance();

export class GeoResp {
    value: string = "";
    data: Address = null;
    cityReadField: string = "";
    get cityValue(){
        const res = !this.data
            ? ""
            : `${this.data.state ?? ""}${this.data.region ? " "+this.data.region+" " : " "}${this.data.city ?? ""}`;
        this.cityReadField = res;
        return res;
    }

    static Create(value: string, data: Address): GeoResp{
        const res = new GeoResp();
        res.value = value;
        res.data = data;
        return res;
    }
}